const MINIMUM_MENTOR_EXPERIENCE = 0;
const MAXIMUM_MENTOR_EXPERIENCE = 15;

export { MINIMUM_MENTOR_EXPERIENCE, MAXIMUM_MENTOR_EXPERIENCE };
